import "../../styles/Modal.css"

import ManagerRemForm from "../forms/ManagerRemForm"

function ManagerRemoveModal({ onClose }) {

  return (
    <div className="m-overlay" >

      <div className="sm-content" >
        <div className="m-header" >
          <h4 className="m-title">Remove Manager</h4>
          <button className="m-cancel-button-x" onClick={onClose}>X</button>
        </div>

        <div className="ma-body" >
          <ManagerRemForm />
        </div>

        <div className="sm-footer" >
          <button className="m-cancel-button" onClick={onClose}>Close</button>
        </div>
      </div>

    </div>
  )
}

export default ManagerRemoveModal
